import { CalendarSpec } from './interface';

export const DEFAULT_CALENDAR_FORMATS: CalendarSpec = {
  lastDay: '[Yesterday,] LT',
  sameDay: '[Today,] LT',
  nextDay: '[Tomorrow,] LT',
  lastWeek: 'Do MMM, YYYY, LT',
  nextWeek: 'Do MMM, YYYY, LT',
  sameElse: 'Do MMM, YYYY, LT'
};
